import { render, staticRenderFns } from "./PageApplicationMapsFertilization.vue?vue&type=template&id=5b5885d2&"
import script from "./PageApplicationMapsFertilization.vue?vue&type=script&lang=ts&"
export * from "./PageApplicationMapsFertilization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports